import { blockPalette, blockTheme, ContentBlockStyles } from "@gaiaProfessionals/Widgets/HCP/ContentBlocks/HCPContentBlocks.styles";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import styled, { css } from "styled-components";

// <============== Fields Data ==============>
const enum fields {

}

interface OwnProps extends WidgetProps {
    fields: {

    };
}

// <============== Categories Block Styled Component ==============>

const CategoriesBlock = styled.div`
    ${blockTheme.container}
    ${blockTheme.rowMargin}
    display: flex;
    flex-direction: column;
    // Media Queries
    /* Small Devices, Tablets */
        @media screen and (min-width: 768px) {
        flex-direction: row;
    }

    /* =============== Category Block =============== */
    .categoryBlock {
        width: 100%;
        margin-bottom: 2rem;
        // Pseudo Elements
        &:last-of-type {
            margin-bottom: 0;
        }
        // Media Queries
        /* Small Devices, Tablets */
        @media screen and (min-width: 768px) {
            width: 33.333%;
            margin-right: 3%;
            margin-bottom: 0;
            // Pseudo Elements
            &:last-of-type {
                margin-right: 0;
            }
        }
    }
`;

// <============== Component ==============>
const HCPCategories: FC<OwnProps> = ({ fields, id }) => {

    return (
        <ContentBlockStyles>
            <CategoriesBlock>
                <div className="categoryBlock">
                    <Zone contentId={id} zoneName="categoryOne"></Zone>
                </div>
                <div className="categoryBlock">
                    <Zone contentId={id} zoneName="categoryTwo"></Zone>
                </div>
                <div className="categoryBlock">
                    <Zone contentId={id} zoneName="categoryThree"></Zone>
                </div>
            </CategoriesBlock>
        </ContentBlockStyles>
    );
};

// <============== Widget Fields ==============>
const contentTab = {
    displayName: "Content",
    sortOrder: 1,
};

const HCPCategoriesBlock: WidgetModule = {
    component: HCPCategories,
    definition: {
        group: "Common",
        icon: "Banner",
        displayName: "HCP Categories Block",
        fieldDefinitions: [

        ],
    },
};

export default HCPCategoriesBlock;
